var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 0.000244141H0V32.6662H49V0.000244141Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 0V16.333H24.5L0 0H49Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 16.333V32.666H0L24.5 16.333H49Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4955 16.333L12.8839 15.1046L14.2747 12.5754L11.4388 13.1178L11.0794 10.2532L9.10414 12.3601L7.12892 10.2532L6.76956 13.1178L3.93378 12.5753L5.32444 15.1045L2.71289 16.333L5.32444 17.5613L3.93378 20.0906L6.76975 19.5481L7.12892 22.4128L9.10414 20.3059L11.0794 22.4128L11.4388 19.5481L14.2746 20.0907L12.8838 17.5615L15.4955 16.333Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08555 3.08887L2.95463 4.30391L4.3786 3.85277L3.49162 5.0548L4.36071 6.26965L2.94344 5.79764L2.05646 6.99957L2.06766 5.50584L0.650391 5.03364L2.07445 4.58269L2.08555 3.08887Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08555 25.6676L2.95463 26.8827L4.3786 26.4315L3.49162 27.6335L4.36071 28.8485L2.94344 28.3764L2.05646 29.5782L2.06766 28.0846L0.650391 27.6124L2.07445 27.1614L2.08555 25.6676Z",
    fill: "#FFDA44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1348 14.3784L19.2658 15.5934L17.8418 15.1423L18.7288 16.3443L17.8597 17.5593L19.277 17.0872L20.1639 18.289L20.1527 16.7954L21.57 16.3232L20.1459 15.8722L20.1348 14.3784Z",
    fill: "#FFDA44"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/Philippines.fe50b61d6564567022e0d5325173cd89.svg";
export { ForwardRef as ReactComponent };